import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function AuthImage({ src, alt, className, testid }) {
  const isStored = src?.startsWith("/api/files/");
  const [url, setUrl] = useState(isStored ? "" : src);

  useEffect(() => {
    if (!isStored) { setUrl(src); return undefined; }
    let objectUrl = "";
    api.get(src.replace(/^\/api/, ""), { responseType: "blob" })
      .then((r) => { objectUrl = URL.createObjectURL(r.data); setUrl(objectUrl); })
      .catch(() => setUrl(""));
    return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [src, isStored]);

  if (!url) return <div className={`${className} bg-violet-100 animate-pulse`} />;
  return <img data-testid={testid} src={url} alt={alt} className={className} />;
}
